export const DutyPaidOptions = [
	{
		id: 'T1',
		label: 'T1',
	},
	{
		id: 'IMPORT',
		label: 'IMPORT',
	},
];

export const SHIPPING_TYPE_COLOR = '#009ab6'